import { culturalsData } from "./culturalsData";
import { data1 } from "./data1";
import { data2 } from "./data2";
import { data3 } from "./data3";


export const participantsData = [
    ...data1,
    ...data2,
    ...data3,
    ...culturalsData
]

